import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, Modal, Paper, TextField } from '@material-ui/core';
import Scrollbars from 'react-custom-scrollbars';

import useActions from 'modules/map/useActions';
import { ButtonPrimary } from 'core/ui/Button';
import Modules from 'modules';
import useSelectors from 'modules/map/useSelectors';
import { helpVideoModule } from 'modules/helpVideo';
import Divider from 'core/ui/Divider';

import { withHealedCurrentPath } from 'hocs/withHealedCurrentPath';
import { useStyles } from './styles';
import { Item } from './Item';
import { AddNewHelpVideoButton } from './AddNewHelpVideoButton';

export const AdminArea = ({ currentHelpVideos, currentPath, getMappedHelpVideos }) => {
  const helpVideosToSelect = useSelectors(helpVideoModule, 'helpVideos');

  const { request } = useActions();

  const classes = useStyles();

  const [opened, setOpened] = useState(false);
  const [search, setSearch] = useState('');

  const alreadyAddedHelpVideoIds = useMemo(
    () => new Set(currentHelpVideos.map((helpVideo) => helpVideo.id)),
    [currentHelpVideos],
  );

  const filteredHelpVideosToSelect = useMemo(() => {
    if (search.length <= 0) return helpVideosToSelect;

    const healedSearch = search.toLowerCase();

    return helpVideosToSelect.filter((helpVideo) =>
      helpVideo.title.toLowerCase().includes(healedSearch),
    );
  }, [search, helpVideosToSelect]);

  const getHelpVideosToSelect = useCallback(() => {
    request({ action: Modules.helpVideo.actions.index });
  }, [request]);

  const onClose = () => {
    getMappedHelpVideos();
    setOpened(false);
  };

  useEffect(() => {
    getHelpVideosToSelect();
  }, [getHelpVideosToSelect]);

  return (
    <Box className={classes.container}>
      {process.env.NODE_ENV === 'development' && <DebugHealedPath />}

      <ButtonPrimary onClick={() => setOpened(true)}>Add</ButtonPrimary>

      <Modal open={opened} onClose={onClose} className={classes.modal}>
        <Paper className={classes.paper}>
          <Box className={classes.header}>
            <TextField
              label="Search"
              variant="outlined"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ maxWidth: 300, width: '100%' }}
            />

            <AddNewHelpVideoButton getHelpVideosToSelect={getHelpVideosToSelect} />
          </Box>

          <Divider />

          <Scrollbars style={{ height: '100%', width: '100%' }}>
            <div className={classes.grid}>
              {filteredHelpVideosToSelect.map((helpVideo) => (
                <Item
                  key={helpVideo.id}
                  helpVideo={helpVideo}
                  currentPath={currentPath}
                  alreadyAdded={alreadyAddedHelpVideoIds.has(helpVideo.id)}
                  getMappedHelpVideos={getMappedHelpVideos}
                  getHelpVideosToSelect={getHelpVideosToSelect}
                />
              ))}
            </div>
          </Scrollbars>
        </Paper>
      </Modal>
    </Box>
  );
};

const DebugHealedPath = withHealedCurrentPath(({ healedCurrentPath }) => {
  return healedCurrentPath ?? 'undefined';
});
